import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BranchesComponent } from './branches.component';
import { BranchAddComponent } from './branch.add.component';
import { CoreService } from '../core/core.service';

const routes: Routes = [
  CoreService.childRoutes([
    { path: 'branches', component: BranchesComponent, data: { title: 'Branches' } },
    { path: 'branchadd', component: BranchAddComponent, data: { title: 'Add Branch' } },
  ])
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class TransactionRoutingModule { }
